module.exports = __webpack_public_path__ + "static/media/allergy_nuts.efdd596a.png";